import { render, staticRenderFns } from "./GridPlaceCategories.vue?vue&type=template&id=10c1df47&"
import script from "./GridPlaceCategories.vue?vue&type=script&lang=js&"
export * from "./GridPlaceCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10c1df47')) {
      api.createRecord('10c1df47', component.options)
    } else {
      api.reload('10c1df47', component.options)
    }
    module.hot.accept("./GridPlaceCategories.vue?vue&type=template&id=10c1df47&", function () {
      api.rerender('10c1df47', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/placesCategories/grid/GridPlaceCategories.vue"
export default component.exports